import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Fieldset } from 'foundations-components/transitional/components/Fieldset';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Link } from 'foundations-components/transitional/components/Link';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { LinkRelDefault, LinkRelTypes } from '../../constants/link';
import { CustomizeLinkAttributesUrl, sharedI18nKey } from '../../constants/shared';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const renderRelRadioButton = (relType, curRelAttr = [], onChange, disabled) => {
  let checked = curRelAttr.includes(relType);
  if (relType === LinkRelTypes.REGULAR) {
    checked = curRelAttr.length === 0 || curRelAttr.length === 1 && curRelAttr[0] === LinkRelDefault;
  }
  return /*#__PURE__*/_jsx(Checkbox, {
    disabled: disabled,
    checked: !disabled && checked,
    onChange: () => onChange(relType, !checked),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `RichTextLib.links.advanced.rel.${relType}`
    })
  }, `rel-type-${relType}`);
};
function LinkAdvancedPopoverControls(props) {
  const {
    relAttr,
    onRelAttrChange,
    disabled
  } = props;
  const handleRelAttrChange = (relType, checked) => {
    let updatedRelAttr;
    if (relType === LinkRelTypes.REGULAR) {
      updatedRelAttr = [];
    } else {
      updatedRelAttr = checked ? [...relAttr, relType] : relAttr.filter(attr => attr !== relType);
    }
    onRelAttrChange(updatedRelAttr);
  };
  let tooltip;
  if (disabled) {
    tooltip = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "RichTextLib.links.advanced.disabledTooltip"
    });
  } else {
    tooltip = /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "RichTextLib.links.advanced.help"
      }), ' ', /*#__PURE__*/_jsx(Link, {
        href: CustomizeLinkAttributesUrl,
        external: true,
        onMouseDown: evt => evt.preventDefault(),
        use: "on-dark",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: sharedI18nKey('learnMore')
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx(Fieldset, {
    _size: "small",
    children: /*#__PURE__*/_jsx(FormControl, {
      label: I18n.text('RichTextLib.links.advanced.label'),
      tooltip: tooltip,
      tooltipPlacement: "top right",
      tooltipProps: {
        onMouseDown: evt => evt.preventDefault()
      },
      children: /*#__PURE__*/_jsx(ToggleGroup, {
        name: "rel-type",
        children: Object.values(LinkRelTypes).map(relType => renderRelRadioButton(relType, relAttr, handleRelAttrChange, disabled))
      })
    })
  });
}
LinkAdvancedPopoverControls.displayName = 'LinkAdvancedPopoverControls';
export default LinkAdvancedPopoverControls;